import type { BannerPosition, BannerDetails, BannersState } from "../types";

export const loadBannersStart = () => ({
  type: "LOAD_BANNERS_START" as const,
});

export const loadBanners = (fetchedBanners: Partial<BannersState>) => ({
  type: "LOAD_BANNERS" as const,
  payload: fetchedBanners,
});

export const loadBanner = (bannerDetails: Partial<BannerDetails> & Record<string, any>) => ({
  type: "LOAD_BANNER" as const,
  payload: bannerDetails,
});

export const saveBanner = () => ({
  type: "SAVE_BANNER" as const,
});

export const setBannerPositions = (bannerPositions: BannerPosition[]) => ({
  type: "SET_POSITIONS" as const,
  positions: bannerPositions,
});

export const setBannerPosition = (bannerPosition: BannerPosition) => ({
  type: "SET_POSITION" as const,
  position: bannerPosition,
});

export const setSelectedPositions = (bannerPositions: BannerPosition[]) => ({
  type: "SET_SELECTED_POSITIONS" as const,
  positions: bannerPositions,
});

export const setFilterPosition = (position: string) => ({
  type: "SET_FILTER_POSITION" as const,
  selectedPosition: position,
});
